module.exports = __webpack_public_path__ + "static/media/refer.c9d3b537.png";